import { render } from "./LogoSVG.vue?vue&type=template&id=3bf5d10a"
const script = {}

import "./LogoSVG.vue?vue&type=style&index=0&id=3bf5d10a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__